import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './App.css';
import { useInterval } from './hooks';
import DashView from './views/DashView';
import DefaultView from './views/DefaultView';
import EnvironmentBar from './components/EnvironmentBar';
import { fetchClass } from './library/BffFuncs.js';
import { renderTimespanToAgoPhrase } from './library/DateTimeFuncs.js';

// all views that we support
const VIEWS = {
  default: "default",
  dash: "dash"
};

function App() {
  // define state and defaults
  const [dateTimeDependency, setDateTimeDependency] = useState(new Date());
  const [dateTimeLastLoaded, setDateTimeLastLoaded] = useState(new Date());
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [theClass, setTheClass] = useState(undefined);

  // use the uniqueRef if it is part of the route params
  let { uniqueRef } = useParams();
  
  // fetch parameters from the URI
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  
  // if we don't have a uniqueRef as a route param then try get it from the query params
  if (!uniqueRef) {
    uniqueRef = urlParams.get("uniqueRef");
  }
  
  // determine the selected view from the URI
  const viewParam = urlParams.get("view");
  
  let renderView;
  switch (viewParam === undefined || viewParam === null ? VIEWS.default : viewParam.toLowerCase()) {
    case VIEWS.dash:
      renderView = <DashView uniqueRef={uniqueRef} theClass={theClass} loadingMessage={loadingMessage} isFirstLoad={isFirstLoad} />;
      break;
    default:
      renderView = <DefaultView uniqueRef={uniqueRef} theClass={theClass} loadingMessage={loadingMessage} isFirstLoad={isFirstLoad} />
      break;
  }

  // define class loader function (running in intervals)
  useInterval(() => {
    setDateTimeDependency(new Date())
  }, 1000); // polls for updates every 1 second

  useEffect(() => {
    async function fetchTheClass() {
      // quick exit if something is loading
      if (isLoading) {
        return;
      }

      // quick exit if the class has been fetched just recently, so we won't fetch right now
      let timeSpan = new Date() - dateTimeLastLoaded;
      if (!isFirstLoad && timeSpan < 59.5 * 1000) { // nearly 1 minute
        setLoadingMessage(renderTimespanToAgoPhrase(dateTimeLastLoaded, "Info refreshed "));
        return;
      }

      // fetch the class
      setIsLoading(true);
      setLoadingMessage("Refreshing ...");
      var loadedClass = await fetchClass(uniqueRef);
      setIsFirstLoad(false);
      setTheClass(loadedClass);
      setDateTimeLastLoaded(new Date()); // remember when the class was loaded last (for status rendering)

      // remove loading message
      setIsLoading(false);
    }
    fetchTheClass();
  }, [dateTimeDependency, dateTimeLastLoaded, isFirstLoad, isLoading, uniqueRef]);

  return (
    <div className="app">
      <EnvironmentBar />
      {renderView}
    </div>
  );
}

export default App;